import React , {useLayoutEffect, useState} from 'react'
import { FPSInfo , QRTimeOut , QRFormat ,components_css ,QRRenderer , GenerateQRButton} from './components'
import resource from '../resource.js'
import apis from '../api.js' 

export default function(props){
    document.title=props.title
     
    const [qrDetails, setqrDetails] = useState({})

    useLayoutEffect(() => {
        document.getElementById('TransactionAmount').value = 0 
    })
 
    var qrHolderID = 'QRHolder';

    let genQRCodeVal  = ()=> {


        document.getElementById(qrHolderID).style.visibility  = 'hidden';
        setqrDetails({})
        let queryBody = { } 

        let kvPairs = {}
        kvPairs['PointofInitiationMethod'] = 'PointofInitiationMethod'
        kvPairs['EnableTimeOut'] = 'MerchantTimeOuttimeEnabled'
        kvPairs['TimeoutHH'] = 'MerchantTimeOuttimeHH'
        kvPairs['TimeoutMM'] = 'MerchantTimeOuttimeMM'
        kvPairs['TimeoutSS'] = 'MerchantTimeOuttimeSS'
        kvPairs['BillType'] = 'BillType'
        kvPairs['RefLabelValue1'] = 'RefLabelValue1'
        kvPairs['RefLabelValue2'] = 'RefLabelValue2'
        kvPairs['RefLabelValue3'] = 'RefLabelValue3'
        kvPairs['Amount'] = 'TransactionAmount'
        kvPairs['Currency'] = 'TransactionCurrency'
        kvPairs['EditableAmount'] = 'EditableTransactionAmountIndicator'

        Object.keys(kvPairs).forEach(k => { 
            queryBody[k] = document.getElementById(kvPairs[k]) .value 
        });

        apis.getQRCodeVal( queryBody )
            .then ( async data=> {
                console.log(data); 
                if (data['ok']){
                    await setqrDetails( {
                        ...qrDetails
                        , code: data.msg.code 
                        , billNumRef :  data.msg.BillNumberReferenceLabel
                        , editable:  data.msg.EditableAmount
                        , FPSIdentifier: data.msg.FPSIdentifier
                        , MerchantName: data.msg.MerchantName
                    })
 
 
                    document.getElementById(qrHolderID).style.visibility= 'visible';
                }else{
                    throw new Error( data.msg);
                }
            })
            .catch(err=>{
                // console.log(err.msg)
                alert(err.message)
            } )

    }

    return( 
        <div>
            <div className='form'>
                <h1>Create QR Code</h1>
                <hr/ > 
                <FPSInfo /> 
                <QRTimeOut />

                <div>
                    <h2>Bill Type:</h2>
                    <div className='panel' >
                        <label>Bill Type</label>
                        <select id="BillType"   
                        >{
                            resource.billtype.map( (bt) => {
                            return <option value={bt.val} selected={bt.default}  >{bt.text}</option>
                            })
                            }
                        </select>
                        <label>
                            Reference Label Value 1 (Partner ID/Event Participant ID/Pledge ID/Event Online Registration Code/Online Invoice Number/Online Reference Number/Donation Notice Number/Others)
                        </label> 
                        <input type="text" id="RefLabelValue1" maxLength="17"  />
                        <label>Designation Code</label>
                        <input type="text" id="RefLabelValue2" maxLength="5"  />
                        <label>Motivation Code</label>
                        <input type="text" id="RefLabelValue3" maxLength="5"  />
                    </div> 
                </div>

                <div>
                    <h2>Amount: </h2>
                    <div className="panel" > 
                        <label>Currency</label>
                        <select id='TransactionCurrency'> 
                            { 
                                    resource.currency.map((c)=>{
                                return  <option value={c.val} >{c.text}</option>
                                    }) 
                            }
                        </select>
                        <label>Transaction Amount (If you want the users input by themselves, please enter 0) </label>
                        <input type="number" id="TransactionAmount"  pattern="\d+(\.\d{1,2})?" />
                        <label>Editable Amount</label>
                        <select id='EditableTransactionAmountIndicator'>
                            <option value='06011'>Yes</option>
                            <option value=''>No</option>
                        </select>
                    </div>
                </div>

                {/* <QRFormat />   */}
            </div>
            <div className='form' > 
                <GenerateQRButton onButtonClicked={genQRCodeVal} />
                <div>
                    <h2>FPS QR Code:</h2>
                    <div className='panel'>
                    <div id={qrHolderID}>
                    <QRRenderer   valToRender={qrDetails.code} />   
                    </div>
  
                    
                    </div>

                    <h2>FPS Details:</h2>
                    <div className='panel'>

                    <label><b>WVHK FPS ID</b></label>
                    <p>{qrDetails.FPSIdentifier}</p>

                    <label><b>Merchant Name</b></label>
                    <p>{qrDetails.MerchantName}</p>

                    <label><b>QR Code Value:</b></label>
                    <p  id="qrValue"  >{qrDetails.code}</p> 

                    <label><b>Editable Amount: </b></label>
                    <p>{qrDetails.editable}</p>

                    <label><b>Bill Number Reference Label:</b></label>
                    <p>{qrDetails.billNumRef}</p>
                    </div>
                </div>


            </div>
        </div>
    )
}

